export function timeoutSuccess<T>(timeout: number, result?: T): Promise<T> {
    return new Promise((resolve) => {
        setTimeout(resolve, timeout, result);
    });
}
